var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "sysOrgGroup:list",
                        expression: "'sysOrgGroup:list'",
                      },
                    ],
                    staticClass: "filter-item",
                    staticStyle: { width: "300px" },
                    attrs: {
                      placeholder: _vm.$t("placeholder.PleaseNameLogo"),
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "keywords", $$v)
                      },
                      expression: "listQuery.keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        { name: "waves", rawName: "v-waves" },
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "sysOrgGroup:list",
                          expression: "'sysOrgGroup:list'",
                        },
                      ],
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v(_vm._s(_vm.$t("buttons.Search")) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        { name: "waves", rawName: "v-waves" },
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "sysOrgGroup:update",
                          expression: "'sysOrgGroup:update'",
                        },
                      ],
                      staticClass: "filter-item",
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        type: "primary",
                        icon: "el-icon-circle-plus-outline",
                      },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v(_vm._s(_vm.$t("buttons.Add")) + "\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.orgGroupList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.OrgGrouping"),
              align: "center",
              width: "100",
              prop: "orgGroupId",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.GroupName"),
              "min-width": "100px",
              align: "center",
              prop: "orgGroupName",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.SubgroupCode"),
              prop: "orgGroupCode",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t("tableFrom.CreationTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.createTime,
                            "{y}-{m}-{d} {h}:{i}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t("tableFrom.UpdateTime") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.updateTime,
                            "{y}-{m}-{d} {h}:{i}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-button", {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "sysOrgGroup:update",
                          expression: "'sysOrgGroup:update'",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-edit",
                        circle: "",
                        title: _vm.$t("buttons.Edit"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleUpdate(row)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("el-button", {
                      directives: [
                        {
                          name: "has",
                          rawName: "v-has",
                          value: "sysOrgGroup:delete",
                          expression: "'sysOrgGroup:delete'",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        type: "danger",
                        icon: "el-icon-delete",
                        circle: "",
                        title: _vm.$t("buttons.Delete"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleDelete(row)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-s-data",
                        circle: "",
                        title: _vm.$t("buttons.grantAuth"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleOrgRes(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("sw-page", {
            key: "2",
            attrs: {
              listQuery: _vm.listQuery,
              total: _vm.total,
              pos: "btmRight",
            },
            on: { retPage: _vm.retPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addOrEditDialogData.visible
        ? _c("add-or-edit-dialog", {
            attrs: { addOrEditData: _vm.addOrEditDialogData },
            on: { refresh: _vm.refreshList },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.authDialogData.visible
        ? _c("auth-dialog", {
            attrs: { authData: _vm.authDialogData },
            on: { refresh: _vm.refreshList },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }